import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IManagementReviewBoard, defaultValue } from 'app/shared/model/management-review-board.model';

export const ACTION_TYPES = {
  FETCH_MANAGEMENTREVIEWBOARD_LIST: 'managementReviewBoard/FETCH_MANAGEMENTREVIEWBOARD_LIST',
  FETCH_MANAGEMENTREVIEWBOARD: 'managementReviewBoard/FETCH_MANAGEMENTREVIEWBOARD',
  CREATE_MANAGEMENTREVIEWBOARD: 'managementReviewBoard/CREATE_MANAGEMENTREVIEWBOARD',
  UPDATE_MANAGEMENTREVIEWBOARD: 'managementReviewBoard/UPDATE_MANAGEMENTREVIEWBOARD',
  DELETE_MANAGEMENTREVIEWBOARD: 'managementReviewBoard/DELETE_MANAGEMENTREVIEWBOARD',
  RESET: 'managementReviewBoard/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IManagementReviewBoard>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type ManagementReviewBoardState = Readonly<typeof initialState>;

// Reducer

export default (state: ManagementReviewBoardState = initialState, action): ManagementReviewBoardState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MANAGEMENTREVIEWBOARD_LIST):
    case REQUEST(ACTION_TYPES.FETCH_MANAGEMENTREVIEWBOARD):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_MANAGEMENTREVIEWBOARD):
    case REQUEST(ACTION_TYPES.UPDATE_MANAGEMENTREVIEWBOARD):
    case REQUEST(ACTION_TYPES.DELETE_MANAGEMENTREVIEWBOARD):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_MANAGEMENTREVIEWBOARD_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MANAGEMENTREVIEWBOARD):
    case FAILURE(ACTION_TYPES.CREATE_MANAGEMENTREVIEWBOARD):
    case FAILURE(ACTION_TYPES.UPDATE_MANAGEMENTREVIEWBOARD):
    case FAILURE(ACTION_TYPES.DELETE_MANAGEMENTREVIEWBOARD):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MANAGEMENTREVIEWBOARD_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MANAGEMENTREVIEWBOARD):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_MANAGEMENTREVIEWBOARD):
    case SUCCESS(ACTION_TYPES.UPDATE_MANAGEMENTREVIEWBOARD):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_MANAGEMENTREVIEWBOARD):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/management-review-boards';

// Actions

export const getEntities: ICrudGetAllAction<IManagementReviewBoard> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_MANAGEMENTREVIEWBOARD_LIST,
  payload: axios.get<IManagementReviewBoard>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IManagementReviewBoard> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_MANAGEMENTREVIEWBOARD,
    payload: axios.get<IManagementReviewBoard>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IManagementReviewBoard> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MANAGEMENTREVIEWBOARD,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IManagementReviewBoard> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MANAGEMENTREVIEWBOARD,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IManagementReviewBoard> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MANAGEMENTREVIEWBOARD,
    payload: axios.delete(requestUrl),
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
